/**
 *
 * Asynchronously loads the component for VerifyInvite
 *
 */

import { lazyLoad } from 'utils/loadable';

export const VerifyInvite = lazyLoad(
  () => import('./index'),
  module => module.VerifyInvite,
);
